module.exports = {"id":"221564","name":"Nahuel Leiva","rating":"72","photo":"./data/images/photos/0/221564.png","club":{"name":"FC Barcelone B","logo":"./data/images/clubs/FCBarceloneB.png"},"positions":["MD","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/NahuelLeiva0.json
// module id = 3127
// module chunks = 0